import { BaseHttpBypassService } from './base-http-bypass.service';
import { AuthService } from './../services/auth.service';
import { EventsService } from './../services/events.service';
import { BaseHttpService } from './base-http.service';
import { OnInit, OnDestroy, EventEmitter, Directive, inject } from '@angular/core';

import { AppInjecterService } from './../services/app-injecter.service';
import {
  AlertController,
  NavController,
  LoadingController,
  PopoverController,
  ModalController,
  ToastController,
} from '@ionic/angular';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';
// import * as FileSaver from 'file-saver';
import { saveAs } from 'file-saver';
import { jsPDF } from 'jspdf'
import autoTable from 'jspdf-autotable'
import { Storage } from '@ionic/storage';
import { AnalyticsService } from '../services/analytics.service';
import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
// import { jsPDF } from "jspdf";
// import { autoTable } from 'jspdf-autotable'
// declare let jsPDF: any;

@Directive()
export abstract class BaseInjectorService
  implements OnInit, OnDestroy {
  alertCtrl: AlertController;
  navCtrl: NavController;
  router: Router;
  loadingCtrl: LoadingController;
  popoverCtrl: PopoverController;
  toastCtrl: ToastController;
  // modalCtrl: ModalController;
  baseHttp: BaseHttpService;
  baseHttpBypass: BaseHttpBypassService;
  auth: AuthService;
  analytics: AnalyticsService;
  eventSevice: EventsService;
  storage: Storage;
  loader;
  modal;
  alert;
  popover;
  toast;
  EXCEL_TYPE =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  EXCEL_EXTENSION = '.xlsx';
  public settingsJSON = {
    recordCount: '',
    columns: []
  };
  modalCtrl: ModalController;



  constructor() {
    this.alertCtrl = inject(AlertController);
    this.navCtrl = inject(NavController);
    this.router = inject(Router);
    this.loadingCtrl = inject(LoadingController);
    this.popoverCtrl = inject(PopoverController);
    this.toastCtrl = inject(ToastController);
    // this.modalCtrl = AppInjecterService.injector.get(ModalController);
    this.baseHttp = inject(BaseHttpService);
    this.baseHttpBypass = inject(BaseHttpBypassService);
    this.auth = inject(AuthService);
    this.analytics = inject(AnalyticsService);
    this.eventSevice = inject(EventsService);
    this.storage = inject(Storage);
    this.modalCtrl = inject(ModalController);
  }
  ngOnInit(): void {
    // console.log('base init');
  }
  ngOnDestroy(): void {
    // console.log('base destroy');
  }
  async simpleAlert(head, subhead?: string, msg?: string, btns?: any) {
    const alert = await this.alertCtrl.create({
      header: head,
      subHeader: subhead,
      message: msg,
      buttons: btns || ['OK']
    });
    alert.present();
    await alert.onDidDismiss();
  }
  async presentLoader(options?: object) {
    this.loader = await this.loadingCtrl.create({
      message: (options && options['message']) || '',
      translucent: true,
      backdropDismiss: false,
      spinner: 'bubbles',
      cssClass: 'custom-loader',
      duration: (options && options['duration']) || 180000
    });
    return await this.loader.present();
  }

  async dismissLoader() {
    return await this.loader.dismiss();
    // while ((await this.loadingCtrl.getTop()) !== undefined) {
    //   await this.loadingCtrl.dismiss();
    // }
  }

  async presentPopover(compName, ev, cssStyle?: any) {
    this.popover = await this.popoverCtrl.create({
      component: compName,
      event: ev,
      cssClass: cssStyle,
      translucent: true
    });
    await this.popover.present();
    return this.popover;
  }

  dismissPopOver(data?: any) {
    this.popoverCtrl.dismiss(data);
  }

  async presentAlert(head: string, msg?: string, btns?: any) {
    this.alert = await this.alertCtrl.create({
      header: head,
      message: msg,
      buttons: btns || ['OK'],
      backdropDismiss: false
    });
    await this.alert.present();
    return this.alert;
  }

  // async presentModal(componentName, data?: {}, cssObj?: any) {
  //   this.modal = await this.modalCtrl.create({
  //       component: componentName,
  //       componentProps: data,
  //       cssClass: cssObj
  //   });
  //   await this.modal.present();
  //   return this.modal;
  // }

  // dismissModal() {
  //   this.modalCtrl.dismiss();
  //   // this.modal.dismiss();
  // }

  // async presentAlert(head, msg?: string, btns?: any) {
  //   this.alert = await this.alertCtrl.create({
  //     header: head,
  //     message: msg,
  //     buttons: btns || ['OK'],
  //     backdropDismiss: false
  //   });
  //   await this.alert.present();
  //   return this.alert;
  // }

  async presentToast(msg) {
    this.toast = await this.toastCtrl.create({
      message: msg,
      duration: 2000,
      position: 'bottom'
    });
    await this.toast.present();
    return this.toast;
  }

  displayPdf(url) {
    // window.open(environment.base_url.hanzapp.url + url);
    window.open(environment.base_url_bypass.hanzappbypass.url + url);
  }

  async exportAsExcelFile(json: any[], excelFileName: string) {
    excelFileName = excelFileName.charAt(0) === '/' ? excelFileName.slice(1) : excelFileName;
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const header = Object.keys(json[0]);
    var wscols = [];
    for (var i = 0; i < header.length; i++) {
      wscols.push({ wch: header[i].length })
    }
    worksheet["!cols"] = wscols;
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ['data']
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });
    this.saveAsExcelFile(excelBuffer, excelFileName);
    this.saveCarrierAudit(excelFileName, "downloadExcel")
  }

  private saveAsExcelFile(buffer: any, fileName: string) {
    const data: Blob = new Blob([buffer], {
      type: this.EXCEL_TYPE
    });
    saveAs(data, fileName + this.EXCEL_EXTENSION);
    this.analytics.gaLogEvent('download_master_data', { path: fileName });
  }

  async exportAsPdf(pdfArr, filename) {
    filename = filename.charAt(0) === '/' ? filename.slice(1) : filename;
    const doc = new jsPDF('l', 'pt', 'a3');
    doc.setFont('Times New Roman');
    let header = [];
    const rows = [];
    if (!this.isEmpty(pdfArr)) {
      header = Object.keys(pdfArr[0]);
      for (const item of pdfArr) {
        const tempArr = [];
        for (let key in item) {
          tempArr.push(item[key]);
        }
        rows.push(tempArr);
      }
      // doc.autoTable(header, rows, {
      //   theme: 'striped',
      //   styles: {
      //     cellPadding: 2,
      //     fontSize: 9,
      //     overflow: 'linebreak'
      //   },
      //   showHead: 'everyPage',
      //   startY: 50,
      // });
      autoTable(doc, {
        columns: header,
        body: rows,
        theme: 'striped',
        styles: {
          cellPadding: 2,
          fontSize: 9,
          overflow: 'linebreak'
        },
        showHead: 'everyPage',
        startY: 50
      });
      doc.save(filename + '.pdf');
      this.saveCarrierAudit(filename, "downloadPDF");
    }
  }

  getStorageData(key) {
    return new Promise((resolve) => {
      this.storage.get(key).then((data) => {
        console.log('data', data);
        if (data !== undefined) {
          resolve(data);
        } else {
          resolve(false);
        }
      }, (error) => {
        resolve(false);
      });
    }).catch(() => {
      throw new Error('Promise failure');
    });
  }

  setStorage(key, input) {
    return new Promise((resolve) => {
      this.storage.set(key, input);
      resolve(true);
    })
  }

  isEmpty(input) {
    if (
      input === null ||
      input === undefined ||
      // input === [] ||
      (Array.isArray(input) && input.length === 0) ||
      input.length < 0 ||
      // input === {}
      Object.keys(input).length === 0
    ) {
      return true;
    } else {
      return false;
    }
  }

  isNullEmptyVal(input) {
    if (input === null || input === undefined || input === '') {
      return true;
    } else {
      return false;
    }
  }

// Equality with a new object or array is always false because the equality operator tests object identity. Instead, you should compare the contents of the object or array.
  isNullEmpty(input) {
    if (input === null || input === undefined || input === '' || 
      // input === [] || input === {} || input === NaN) {
        (Array.isArray(input) && input.length === 0) || Object.keys(input).length === 0
        || Number.isNaN(input)) {

      return true;
    } else {
      return false;
    }
  }

  async isNumeric(inputStr) {
    if (inputStr && !Number.isNaN(Number(inputStr))) {
      return true;
    } else {
      return false;
    }
  }

  sortAlphanumeric(a, b) {
    var regAlpha = /[^a-zA-Z]/g;
    var regNum = /[^0-9]/g;
    var aInt = parseInt(a, 10);
    var bInt = parseInt(b, 10);
    if (isNaN(aInt) && isNaN(bInt)) {
      var aA = a.replace(regAlpha, "");
      var bA = b.replace(regAlpha, "");
      if (aA === bA) {
        var aN = parseInt(a.replace(regNum, ""), 10);
        var bN = parseInt(b.replace(regNum, ""), 10);
        return aN === bN ? 0 : aN > bN ? 1 : -1;
      } else {
        return aA > bA ? 1 : -1;
      }
    } else if (isNaN(aInt)) {
      return 1;
    } else if (isNaN(bInt)) {
      return -1;
    } else {
      return aInt > bInt ? 1 : -1;
    }
  }

  fetchSettingsFlag(preferenceType) {
    return new Promise(async (resolve) => {
      const userEmail = await this.auth.getUserEmail();
      const reqObject = {
        emailId: userEmail,
        preferenceType: preferenceType
      };
      this.baseHttp.post('auth/rest/prefernce/getPrefernce', reqObject).subscribe(response => {
        if (response) {
          resolve(response);
        } else {
          resolve(false);
        }
      }, (error) => {
        resolve(false);
      });
    }).catch(() => {
      throw new Error('Promise failure');
    });
  }

  fetchSettings(preferenceType) {
    return new Promise(async (resolve) => {
      const userEmail = await this.auth.getUserEmail();
      const reqObj = {
        emailId: userEmail,
        preference: 'Y',
        preferenceType: preferenceType,
        preferenceMaster: JSON.stringify(this.settingsJSON)
      };
        this.baseHttp.post('auth/rest/prefernce/getUserPreference', reqObj).subscribe(response => {
        console.log('response::: ', response);
        if (response) {
          resolve(true);
          // this.saveCarrierAudit(this.router.url.substr(1), "update", reqObj);
        } else {
          resolve(false);
        }
      }, (error) => {
        resolve(false);
      });
    }).catch(() => {
      throw new Error('Promise failure');
    });
  }

  createGridColArr(gridApi) {
    if (gridApi) {
      const columnArr = [];
      gridApi.getAllGridColumns().forEach((column) => {
        // console.log('column field:: ', column.colDef.field, 'NAme : ', column.colDef.headerName, 'visibility:: ', column.visible);
        if (column.colDef.checkboxSelection) {
          columnArr.push({
            id: '',
            value: 'Select Checkbox',
            visibility: true
          });
        }
        else if (!this.isNullEmpty(column.colDef.field)) {
          columnArr.push({
            id: column.colDef.field,
            value: column.colDef.headerName,
            visibility: column.visible
          })
        } else if (column.colDef.children) {
          column.colDef.children.forEach(data => {
            if (!this.isNullEmpty(data.field)) {
              columnArr.push({
                id: column.colDef.field,
                value: column.colDef.headerName,
                visibility: column.colDef.visible
              });
            }
          })
        }
      });
      return columnArr;
    } else {
      return;
    }
  }

  saveCarrierAudit(pageName, pageAction, payload?, oldPayload?) {
    return new Promise(async (resolve) => {
      const userEmail = await this.auth.getUserEmail();
      const reqObject = {
        "pageName": pageName,
        "pageAction": pageAction,
        "actionByUser": userEmail,
        "payload": JSON.stringify(payload),
        "oldPayload": JSON.stringify(oldPayload)
      }
      this.baseHttp.post('auth/rest/carrieraudit/savecarrieraudit', reqObject).subscribe(response => {
        if (response) {
          resolve(response);
        } else {
          resolve(false);
        }
      }, (error) => {
        resolve(false);
      });
    }).catch(() => {
      throw new Error('Promise failure');
    });
  }

  checkExcelAndReturn(requestObj, xlsHeader) {
    return new Promise(async (resolve) => {
      const reader: FileReader = new FileReader();
      reader.readAsBinaryString(requestObj.get('file'));
      reader.onload = (e: any) => {
        /* create workbook */
        const binarystr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });

        /* selected the first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        /* save data */
        const data = XLSX.utils.sheet_to_json(ws);
        console.log(data); // Data will be logged in array format containing objects
        let excelSheetJSON = [];
        for (let i = 0; i < data.length; i++) {
          let o = this.preferredOrder(data[i], xlsHeader);
          excelSheetJSON.push(o);
        }
        console.log(excelSheetJSON);
        // this.saveCarrierAudit(master, "upload", excelSheetJSON);
        resolve(this.createExcel(excelSheetJSON));
      };
    })
  }

  preferredOrder(obj, order) {
    var newObject = {};
    for (var i = 0; i < order.length; i++) {
      if (obj.hasOwnProperty(order[i])) {
        newObject[order[i]] = obj[order[i]];
      }else{
        newObject[order[i]] = '';
      }
    }
    return newObject;
  }

  async createExcel(json: any[]) {
    return new Promise(async (resolve) => {
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
      const header = Object.keys(json[0]);
      var wscols = [];
      for (var i = 0; i < header.length; i++) {
        wscols.push({ wch: header[i].length })
      }
      worksheet["!cols"] = wscols;
      const workbook: XLSX.WorkBook = {
        Sheets: { data: worksheet },
        SheetNames: ['data']
      };
      const excelBuffer: any = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });
      const data: Blob = new Blob([excelBuffer], {
        type: this.EXCEL_TYPE
      });
      const formData = new FormData();
      formData.append('file', data);
      resolve(formData);
    })
  }
  
  SqlInjectionValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

      const value = control.value;

      const isValid =  /^[\+]?[a-zA-Z0-9]+(?:[\w \-\@\.\_#',?!@#$%^&*()\{\}\[\]]*[a-zA-Z0-9\/_$.@\)]+)*$/.test(value);
      
      return !isValid ? { invalidFormat: true } : null;
    };
  }


  XssValidator(val): boolean {
    return /^[\+]?[a-zA-Z0-9]+(?:[\w \-\@\.\_#',?!@#$%^&*()\{\}\[\]]*[a-zA-Z0-9\/_$@\)]+)*$/.test(val);
  }
}
